import { RequestAccessForm } from "./RequestAccessForm";

export default RequestAccessForm;
